import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';
import { MdAdd } from 'react-icons/md';
import { Container, Menus, NewButton } from './styles';

// Importando componentes e servicos
import api from '~/services/api';
import history from '~/services/history';
import Card from '~/components/Card';
import Table from '~/components/Table';
import Load from '~/components/Load';

export default function Integracao() {
  const [integracoes, setIntegracoes] = useState([]);
  const [loading, setLoading] = useState(false);

  const getIntegracoes = useCallback(async () => {
    setLoading(true);
    const response = await api.get('/integracao');

    setIntegracoes(response.data);
    setLoading(false);
  }, []);

  useEffect(() => {
    getIntegracoes();
  }, [getIntegracoes]);

  // Criando dados da coluna
  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'url',
      label: 'Url',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'name',
      label: 'Nome',
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  function handlerEdit(number) {
    history.push(`/integracao-edit/${number}`);
  }

  async function handleDelete(number) {
    try {
      setLoading(true);
      if (number.length > 1) {
        const res = number.map(async num => {
          const response = await api.delete(`/integracao/${num}`);
          return response.data;
        });
        const tr = Promise.all(res);
        const df = Promise.resolve(tr);
        df.then(result => {
          if (result[0] !== undefined) {
            toast.success('Integração deletada com sucesso');
            getIntegracoes();
          }
        });
      } else {
        const response = await api.delete(`/integracao/${number}`);

        if (response.data) {
          toast.success('Integração deletada com sucesso');
          getIntegracoes();
        }
      }
    } catch (error) {
      toast.error('Erro no sistema, contactar o desenvolvedor');
      getIntegracoes();
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return <Load />;
  }

  return (
    <>
      <Container>
        <h4>Integração</h4>
        <Card>
          <Menus>
            <NewButton to="/integracao-new">
              <MdAdd size={16} color="#FFF" />
              Novo
            </NewButton>
          </Menus>
          <Table
            title="Integrações"
            data={integracoes}
            columns={columns}
            ds={handleDelete}
            ed={handlerEdit}
            messages="Você deseja excluir a(s) integração(ões) ?"
            st
          />
        </Card>
      </Container>
    </>
  );
}
